import { atomWithStorage } from 'jotai/utils';
import { ATOM_DEBUG_KEY } from './atomConstants';

//the arguments are (key, initialValue, storage?, options? -> getOnInit gets item value from local storage on atom initialization)
export const isDebugModeAtom = atomWithStorage(ATOM_DEBUG_KEY, false, undefined, { getOnInit: true });
